export const GsCtaServiceFrag = `
fragment GsCtaServiceFrag on GsCtaService { 
  title {
    value
  }
  description {
    value
  }
  image {
    src
    alt
    width
    height
  }
  link {
    url
    text
    target
  }
}`;
